import React from 'react';
import './Contact.css';
import { FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="contact-box">
      <div className="contact-heading">Contact Us</div>
      <p>
        📧 Email: kashmirjobs@outlook.com <br />
        📍 Location: Srinagar, J&K, India
      </p>

      <div className="whatsapp-wrapper">
        <a
          href="https://wa.me/918494056223"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          <FaWhatsapp className="icon" /> Chat on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default Contact;
